import { render, staticRenderFns } from "./BankCreditsAdd.vue?vue&type=template&id=2849f47d"
import script from "./BankCreditsAdd.vue?vue&type=script&lang=js"
export * from "./BankCreditsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports